
import './App.css';
import SalonApp from './components/salon/salon';

function App() {
  return (
    <SalonApp/>
  );
}

export default App;






